import { Options } from "common";
import api from "app/api";

export type LocationListItem = {
  id: number;
  county: string;
  zip: string;
  address: string;
};
export type LocationFormItem = {
  name: string;
  account_id: number;
  address2: string;
  created_at: string;
  created_by: number;
  deleted_at: string;
  deleted_by: number;
} & LocationListItem;

export type LocationOptions = Options;

export function getLocationService() {
  return api.getService<LocationFormItem, LocationListItem, LocationOptions>(
    "locations",
    {
      itemExporter: item => {
        return {LocationForm: item};
      },
    }
  );
}

export function getLocationLimit() {
  return api.get(`/locations/limit`);
}